<table class="table-condensed w-100 border-table">
  <thead class="bg-light border-bottom-table">
    <tr>
      <th class="px-2 w-10-px"></th>
      <th class="px-2 w-45-rem" i18n="@@app.title">Title</th>
      <th class="text-left" i18n="@@app.download">Download</th>
    </tr>
  </thead>
  <tbody>
    <tr class="border-bottom-table">
      <td>
        <ng-container>
          <div class="custom-control custom-checkbox">
            <input id="checkbox_bom_with_price" class="cursor-pointer custom-control-input" type="checkbox"
              [checked]="selectedDocuments | selectCheckboxDocument:documentTypes.BOM_WITH_PRICE"
              (change)="onToggleSelectionDocument(documentTypes.BOM_WITH_PRICE)">
              <label for="checkbox_bom_with_price" class="custom-control-label"></label>
            </div>
          </ng-container>
        </td>
        <td i18n="@@app.bom_with_price">BOM with price</td>
        <td class="d-flex">
          <app-file-download-in-progress
            [loader]="documentLoaderStates?.bomWithPrice">
            <img class="cursor-pointer no-select"
              #downloadBOMWithPrice
              i18n-title="@@app.bom_with_price"
              title="BOM with price" alt=""
              src="/assets/images/pdf_icon.svg"
              (click)="onDownloadBOMWithPrice(downloadBOMWithPrice?.title)"/>
            </app-file-download-in-progress>
            <app-file-download-in-progress
              [loader]="documentLoaderStates?.bomWithPriceXL">
              <img class="cursor-pointer no-select loader-style"
                #downloadBOMWithPriceXLSX
                i18n-title="@@app.bom_with_price"
                title="BOM with price" alt=""
                src="/assets/images/xlsx_small_icon.svg"
                (click)="onDownloadBOMWithPriceXLSX(downloadBOMWithPriceXLSX?.title)"/>
              </app-file-download-in-progress>
            </td>
          </tr>
          <tr class="border-bottom-table">
            <td>
              <ng-container>
                <div class="custom-control custom-checkbox">
                  <input id="checkbox_bom_without_price" class="cursor-pointer custom-control-input" type="checkbox"
                    [checked]="selectedDocuments | selectCheckboxDocument:documentTypes.BOM_WITHOUT_PRICE"
                    (change)="onToggleSelectionDocument(documentTypes.BOM_WITHOUT_PRICE)">
                    <label for="checkbox_bom_without_price" class="custom-control-label"></label>
                  </div>
                </ng-container>
              </td>
              <td i18n="@@app.bom_without_price">BOM without price</td>
              <td class="d-flex">
                <app-file-download-in-progress
                  [loader]="documentLoaderStates?.bomWithOutPrice">
                  <img #downloadBOMWithoutPrice
                    class="cursor-pointer no-select"
                    i18n-title="@@app.bom_without_price"
                    title="BOM without price"
                    alt=""
                    src="/assets/images/pdf_icon.svg"
                    (click)="onDownloadBOMWithoutPrice(downloadBOMWithoutPrice?.title)"/>
                  </app-file-download-in-progress>
                  <app-file-download-in-progress
                    [loader]="documentLoaderStates?.bomWithOutPriceXL">
                    <img class="cursor-pointer no-select loader-style"
                      i18n-title="@@app.bom_without_price"
                      #downloadBOMWithoutPriceXLSX
                      title="BOM without price" alt=""
                      src="/assets/images/xlsx_small_icon.svg"
                      (click)="onDownloadBOMWithoutPriceXLSX(downloadBOMWithoutPriceXLSX?.title)"/>
                    </app-file-download-in-progress>
                  </td>
                </tr>
                @if (enclosure?.enclosureType !== enclosureTypes.NORMAL) {
                  <tr class="border-bottom-table">
                    <td>
                      <ng-container>
                        <div class="custom-control custom-checkbox">
                          <input id="checkbox_enclosure_layout"
                            class="cursor-pointer custom-control-input"
                            type="checkbox"
                            [checked]="selectedDocuments | selectCheckboxDocument:documentTypes.ENCLOSURE_LAYOUT"
                            (change)="onToggleSelectionDocument(documentTypes.ENCLOSURE_LAYOUT)">
                            <label for="checkbox_enclosure_layout" class="custom-control-label"></label>
                          </div>
                        </ng-container>
                      </td>
                      <td i18n="@@app.enclosure_layout">Enclosure Layout</td>
                      <td>
                        <app-file-download-in-progress
                          [loader]="documentLoaderStates?.enclosureLayout">
                          <img #downloadEnclosureLayout
                            class="cursor-pointer no-select"
                            i18n-title="@@app.enclosure_layout"
                            title="Enclosure layout"
                            alt=""
                            src="/assets/images/pdf_icon.svg"
                            (click)="onDownloadEnclosureLayout(downloadEnclosureLayout.title, false)"/>
                          </app-file-download-in-progress>
                        </td>
                      </tr>
                    }
                    @if (enclosure?.enclosureType === enclosureTypes.PRISMA_XS || enclosure?.enclosureType === enclosureTypes.PRAGMA ||  isProjectDocuments) {
                      <tr class="border-bottom-table">
                        <td>
                          <ng-container>
                            <div class="custom-control custom-checkbox">
                              <input id="checkbox_enclosure_layout_with_covers" class="cursor-pointer custom-control-input" type="checkbox"
                                [checked]="selectedDocuments | selectCheckboxDocument:documentTypes.ENCLOSURE_LAYOUT_WITH_COVERS"
                                (change)="onToggleSelectionDocument(documentTypes.ENCLOSURE_LAYOUT_WITH_COVERS)">
                                <label for="checkbox_enclosure_layout_with_covers" class="custom-control-label"></label>
                              </div>
                            </ng-container>
                          </td>
                          <td i18n="@@app.enclosure_layout_w_covers">Enclosure Layout with covers</td>
                          <td>
                            <app-file-download-in-progress
                              [loader]="documentLoaderStates?.enclosureLayoutWithCover">
                              <img class="cursor-pointer no-select"
                                i18n-title="@@app.enclosure_layout_w_covers"
                                #downloadEnclosureLayoutWithCovers
                                title="Enclosure Layout with covers" alt=""
                                src="/assets/images/pdf_icon.svg"
                                (click)="onDownloadEnclosureLayoutWithCovers(downloadEnclosureLayoutWithCovers.title, true)"/>
                              </app-file-download-in-progress>
                            </td>
                          </tr>
                        }
                        <tr class="border-bottom-table">
                          <td>
                            <ng-container>
                              <div class="custom-control custom-checkbox">
                                <input id="checkbox_disposition_without_layout" class="cursor-pointer custom-control-input" type="checkbox"
                                  [checked]="selectedDocuments | selectCheckboxDocument:documentTypes.DISPOSITION_LAYOUT"
                                  (change)="onToggleSelectionDocument(documentTypes.DISPOSITION_LAYOUT)">
                                  <label for="checkbox_disposition_without_layout" class="custom-control-label"></label>
                                </div>
                              </ng-container>
                            </td>
                            <td i18n="@@app.disposition_layout_without_covers">Disposition Layout without covers</td>
                            <td>
                              <app-file-download-in-progress
                                [loader]="documentLoaderStates?.dispositionLayout">
                                <img class="cursor-pointer no-select"
                                  #downloadDispositionLayout
                                  i18n-title="@@app.disposition_layout_without_covers"
                                  title="Disposition Layout without covers"
                                  alt=""
                                  src="/assets/images/pdf_icon.svg"
                                  (click)="onDownloadDispositionLayout(downloadDispositionLayout.title, false)"/>
                                </app-file-download-in-progress>
                              </td>
                            </tr>
                            <tr class="border-bottom-table">
                              <td>
                                <ng-container>
                                  <div class="custom-control custom-checkbox">
                                    <input id="checkbox_disposition_with_layout" class="cursor-pointer custom-control-input" type="checkbox"
                                      [checked]="selectedDocuments | selectCheckboxDocument:documentTypes.DISPOSITION_LAYOUT_WITH_COVERS"
                                      (change)="onToggleSelectionDocument(documentTypes.DISPOSITION_LAYOUT_WITH_COVERS)">
                                      <label for="checkbox_disposition_with_layout" class="custom-control-label"></label>
                                    </div>
                                  </ng-container>
                                </td>
                                <td i18n="@@app.disposition_layout_with_covers">Disposition Layout with covers</td>
                                <td>
                                  <app-file-download-in-progress
                                    [loader]="documentLoaderStates?.dispositionLayoutWithCover">
                                    <img class="cursor-pointer no-select"
                                      #downloadDispositionLayoutWithCovers
                                      i18n-title="@@app.disposition_layout_with_covers"
                                      title="Disposition Layout with covers"
                                      alt=""
                                      src="/assets/images/pdf_icon.svg"
                                      (click)="onDownloadDispositionLayout(downloadDispositionLayoutWithCovers.title, true)"/>
                                    </app-file-download-in-progress>
                                  </td>
                                </tr>
                                @if (!isProjectDocuments && enclosure?.enclosureType !== enclosureTypes.PRISMA_XS) {
                                  <tr class="border-bottom-table">
                                    <td>
                                      <ng-container>
                                        <div class="custom-control custom-checkbox">
                                          <input id="checkbox_disposition_sld" class="cursor-pointer custom-control-input" type="checkbox"
                                            [checked]="selectedDocuments | selectCheckboxDocument:documentTypes.SLD"
                                            (change)="onToggleSelectionDocument(documentTypes.SLD)">
                                            <label for="checkbox_disposition_sld" class="custom-control-label"></label>
                                          </div>
                                        </ng-container>
                                      </td>
                                      <td i18n="@@app.sld">SLD</td>
                                      <td>
                                        <app-file-download-in-progress
                                          [loader]="documentLoaderStates?.sld">
                                          <img appDisableMultipleClickWithNoneEvent
                                            class="cursor-pointer no-select loader-style"
                                            #downloadSld
                                            i18n-title="@@app.sld"
                                            title="SLD"
                                            alt=""
                                            src="/assets/images/pdf_icon.svg"
                                            (click)="onDownloadSld(downloadSld.title)"/>
                                          </app-file-download-in-progress>
                                        </td>
                                      </tr>
                                    }
                                    @if (!isProjectDocuments) {
                                      <tr class="border-bottom-table">
                                        <td>
                                          <ng-container>
                                            <div class="custom-control custom-checkbox">
                                              <input id="checkbox_enclosure_labels"
                                                class="cursor-pointer custom-control-input"
                                                type="checkbox"
                                                [checked]="selectedDocuments | selectCheckboxDocument:documentTypes.DISPOSITION_LABELS"
                                                (change)="onToggleSelectionDocument(documentTypes.DISPOSITION_LABELS)">
                                                <label for="checkbox_enclosure_labels" class="custom-control-label"></label>
                                              </div>
                                            </ng-container>
                                          </td>
                                          <td i18n="@@app.labels_frontside_print">Label document (frontside print)</td>
                                          <td>
                                            <app-file-download-in-progress
                                              [loader]="documentLoaderStates?.labels">
                                              <img appDisableMultipleClickWithNoneEvent
                                                #downloadLabelsEl
                                                class="cursor-pointer no-select"
                                                i18n-title="@@app.labels_frontside_print"
                                                title="Label document (frontside print)"
                                                alt=""
                                                src="/assets/images/pdf_icon.svg"
                                                (click)="onDownloadLabels(downloadLabelsEl.title)"/>
                                              </app-file-download-in-progress>
                                            </td>
                                          </tr>
                                        }
                                        @if (!enclosure?.product?.productCharacteristicsRules?.isResi9CX && !isProjectDocuments) {
                                          <tr class="border-bottom-table">
                                            <td>
                                              <ng-container>
                                                <div class="custom-control custom-checkbox">
                                                  <input id="checkbox_enclosure_labels_back"
                                                    class="cursor-pointer custom-control-input"
                                                    type="checkbox"
                                                    [checked]="selectedDocuments | selectCheckboxDocument:documentTypes.DISPOSITION_LABELS_BACKSIDE"
                                                    (change)="onToggleSelectionDocument(documentTypes.DISPOSITION_LABELS_BACKSIDE)">
                                                    <label for="checkbox_enclosure_labels_back" class="custom-control-label"></label>
                                                  </div>
                                                </ng-container>
                                              </td>
                                              <td i18n="@@app.labels_backside_print">Label document (backside print)</td>
                                              <td>
                                                <app-file-download-in-progress
                                                  [loader]="documentLoaderStates?.labelsBackSide">
                                                  <img appDisableMultipleClickWithNoneEvent
                                                    #downloadLabelsElBackSide
                                                    class="cursor-pointer no-select"
                                                    i18n-title="@@app.labels_backside_print"
                                                    title="Label document (backside print)"
                                                    alt=""
                                                    src="/assets/images/pdf_icon.svg"
                                                    (click)="onDownloadLabelsBackside(downloadLabelsElBackSide.title)"/>
                                                  </app-file-download-in-progress>
                                                </td>
                                              </tr>
                                            }
                                            @if (!isProjectDocuments) {
                                              <tr class="border-bottom-table">
                                                <td>
                                                  <ng-container>
                                                    <div class="custom-control custom-checkbox">
                                                      <input id="checkbox_disposition_rating_plate" class="cursor-pointer custom-control-input" type="checkbox"
                                                        [checked]="selectedDocuments | selectCheckboxDocument:documentTypes.RATING_PLATE"
                                                        (change)="onToggleSelectionDocument(documentTypes.RATING_PLATE)">
                                                        <label for="checkbox_disposition_rating_plate" class="custom-control-label"></label>
                                                      </div>
                                                    </ng-container>
                                                  </td>
                                                  <td i18n="@@app.rating_plate">Rating Plate</td>
                                                  <td class="d-flex">
                                                    <app-file-download-in-progress
                                                      [loader]="documentLoaderStates?.ratingPlate">
                                                      <img appDisableMultipleClickWithNoneEvent
                                                        class="cursor-pointer no-select loader-style"
                                                        #downloadRatingPlate
                                                        i18n-title="@@app.rating_plate"
                                                        title="Rating Plate"
                                                        alt=""
                                                        src="/assets/images/docx_small_icon.svg"
                                                        (click)="onDownloadRatingPlate(downloadRatingPlate.title)"/>
                                                      </app-file-download-in-progress>
                                                      <app-file-download-in-progress
                                                        [loader]="documentLoaderStates?.ratingPlateXL">
                                                        <img appDisableMultipleClickWithNoneEvent
                                                          class="cursor-pointer no-select loader-style"
                                                          #downloadRatingPlateXLSX
                                                          i18n-title="@@app.rating_plate"
                                                          title="Rating Plate"
                                                          alt=""
                                                          src="/assets/images/xlsx_small_icon.svg"
                                                          (click)="onDownloadRatingPlateXLSX(downloadRatingPlateXLSX?.title)"/>
                                                        </app-file-download-in-progress>
                                                      </td>
                                                    </tr>
                                                  }
                                                </tbody>
                                              </table>
